import { getCurrentInstance } from 'vue';

export const useStore = () => {
  try {
    const instance = getCurrentInstance();
    return instance?.proxy.$store;
  } catch (error) {
    console.error('No instance', error);
  }
};
